// extracted by mini-css-extract-plugin
module.exports = {"footer":"dashboard-footer_footer__6Uuxb","slide-up":"dashboard-footer_slide-up__RGExu"};